module.exports = __webpack_public_path__ + "images/help/icn-faq-manage@2x-6047b43a6ee378f542ce7f26735eb971.png";